/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

export { HangerSpecificationFamilyInformationModule } from './hanger-specification-family-information.module';
export { HangerSpecificationFamilyInformation } from './hanger-specification-family-information.component';